import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import flatten from 'flat';

import colors from 'shared-assets/lib/colors';

const StyledSVG = styled(SVG)`
  & svg {
    width: ${props => props.size || 0.75}rem;
    height: ${props => props.size || 0.75}rem;
    & path {
      fill: ${props => props.fillColor || colors.fill.primary};
    }
  }
`;

const Icon = props => (
  <StyledSVG
    cacheGetRequests
    key={props.type}
    src={`/static/assets/icons/${props.type}.svg`}
    {...props}
  />
);

// If you want to add a new icon SVG, the svg file can be saved to shared-assets/assets/icons
// the string of the svg path in the array below
export const types = [
  'angle-bracket-down',
  'angle-bracket-left',
  'angle-bracket-right',
  'angle-bracket-up',
  'arrow-down',
  'arrow-left',
  'arrow-return',
  'arrow-right',
  'arrow-up',
  'attention-alt',
  'attention',
  'bar',
  'calendar',
  'camera-alt',
  'camera',
  'check-mark-alt',
  'check-mark',
  'chevron-down',
  'chevron-up',
  'clipboard',
  'close-alt',
  'close',
  'edit',
  'external-link',
  'group-patients',
  'info-alt',
  'info',
  'kareo-telehealth',
  'kareo-university',
  'lock-alt',
  'lock-icon',
  'lock',
  'magnifier',
  'message',
  'patient-intake-logo',
  'pencil',
  'plus',
  'print-alt',
  'question-alt',
  'question',
  'refresh',
  'remove-circle',
  'sc-calendar',
  'sc-cancel',
  'sc-doctor',
  'sc-dollar',
  'sc-efficiency',
  'sc-love',
  'sc-people',
  'sc-target',
  'star-alt',
  'star',
  'tebra-telehealth',
  'telehealth',
  'three-dots',
  'trash-can-alt',
  'trash-can',
  'unlock-icon',
  'user-alt',
  'user',
  'video-camera',
];

Icon.defaultProps = {
  type: 'question-alt',
  fillColor: colors.primary,
  size: 0.75,
};

Icon.propTypes = {
  type: PropTypes.oneOf(types),
  fillColor: PropTypes.oneOf(Object.values(flatten(colors))),
  size: PropTypes.number,
};

export default Icon;
